const $ = require('jquery')
const Vue = require('vue')
const client = require('sci/helpers/client')

Vue.component('property-picker', {
    props: {
        query: {
            type: Object,
            default () {
                return {}
            }
        },
        label: {
            twoWay: true,
            type: String
        },
        model: {
            twoWay: true,
            default: true
        },
        property: {
            twoWay: true,
            default: null
        },
        compact: {
            default: false
        },
        hidden: {
            default: false
        },
        onSelected: {
            type: Function,
            default: null
        }
    },
    data () {
        return {
            fieldName: '',
            data: {
                items: [],
                search: {},
                pagination: {
                    total: 0
                }
            },
            ui: {
                loading: false,
                search: null,
                page: 1
            }
        }
    },
    ready () {
        this.fieldName = this._props.model.raw
        this.$modal = $(this.$el).find('.modal')
    },
    computed: {
        propertyCode () {
            if (this.property) {
                return this.property.alternative_code || this.property.code
            }

            return 'Não selecionado'
        }
    },
    methods: {
        search () {
            this.ui.loading = true

            client
                .background()
                .post(null, `/properties/search`, {
                    page: this.ui.page,
                    sort: JSON.stringify(this.ui.sort),
                    presenter: 'simple-presenter',
                    ...this.data.search,
                    ...this.query
                })
                .then((data) => {
                    this.data = {
                        items: data.data,
                        search: this.data.search,
                        pagination: data.meta.pagination
                    }
                    this.ui.loading = false
                })
        },
        showModal () {
            $(this.$modal).modal('show')
            if (!this.ui.loading) {
                this.search()
            }
        },
        pushPage (a) {
            this.ui.page = a
            this.search()
        },
        getPropertyImage (property) {
            if (property.photo) {
                return property.photo.thumbnails.xsmall
            }

            return '/assets/images/imagem-nao-disponivel.png'
        },
        pick (item) {
            this.property = item
            this.model = item.id
            $(this.$modal).modal('hide')

            if (this.onSelected) {
                this.onSelected(item)
            }
        }
    },
    watch: {
        'ui.search': function (newVal) {
            this.data.search.user_code = newVal
        }
    },
    template: require('templates/vue-property-picker.html')
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/property-picker.js